import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "@/private-beta.css";

const API = process.env.REACT_APP_BACKEND_URL;

function RequestAccess() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) { setStatus("error"); setErr("Please enter a valid work email."); return; }
    setStatus("loading"); setErr("");
    try {
      await axios.post(`${API}/api/marketing/notify`, { email: email.trim(), name: null });
      setStatus("done");
    } catch (ex) {
      setStatus("error");
      setErr(ex?.response?.data?.detail || "Something went wrong. Please try again.");
    }
  };

  if (status === "done") {
    return <p className="pb-done" data-testid="private-beta-done">Request received. We review every request personally and will be in touch if there is a fit for the next cohort.</p>;
  }

  if (!open) {
    return (
      <div className="pb-actions">
        <button type="button" className="pb-btn" onClick={() => setOpen(true)} data-testid="private-beta-request">Request an invitation</button>
      </div>
    );
  }

  return (
    <form className="pb-form" onSubmit={submit} data-testid="private-beta-form">
      <input
        type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="Work email" className="pb-input" autoComplete="email" data-testid="private-beta-email"
      />
      <button type="submit" className="pb-btn" disabled={status === "loading"} data-testid="private-beta-submit">
        {status === "loading" ? "Sending" : "Send request"}
      </button>
      {status === "error" && <p className="pb-err" data-testid="private-beta-error">{err}</p>}
    </form>
  );
}

export default function PrivateBeta() {
  return (
    <div className="pb" data-testid="private-beta-page">
      <div className="pb-art" aria-hidden>
        <img src="/brand/gateway/gateway-hero-machines.webp" alt="" />
      </div>

      <header className="pb-nav">
        <div className="pb-brand-row">
          <Link to="/" className="pb-brand" aria-label="Crowther" data-testid="private-beta-brand">
            <img src="/brand/gateway/crowther-full-linen.webp" alt="Crowther" />
          </Link>
          <span className="pb-tagline" data-testid="private-beta-tagline">
            AI for Humans
            <svg className="pb-heart" width="18" height="17" viewBox="0 0 24 22" aria-hidden>
              <path d="M12 21s-9-5.5-9-12.5C3 4.4 6.4 2 9.5 2c1.9 0 3.6.9 4.5 2.3C14.9 2.9 16.6 2 18.5 2 21.6 2 25 4.4 25 8.5 25 15.5 12 21 12 21z" transform="translate(-1,0)" fill="#E63946" />
            </svg>
          </span>
        </div>
      </header>

      <main className="pb-stage">
        <h1 className="pb-title">
          <span>Own your</span>
          <span>intelligence.</span>
        </h1>
        <p className="pb-sub" data-testid="private-beta-sub">
          Crowther is in private beta. We are currently onboarding a select group of companies,
          building specialised intelligence for their world, one at a time.
        </p>
        <RequestAccess />
      </main>

      <footer className="pb-foot">
        <span>© {new Date().getFullYear()} Crowther</span>
        <a href="mailto:hello@crowther.ai" data-testid="private-beta-contact">hello@crowther.ai</a>
      </footer>
    </div>
  );
}
